
<template>
  <m-layout>
    <div fill-height class="fill-height" style="max-width:100%; position:relative">
      <v-card-title class="m-page__title">
        <span class="headline">{{ $t('denied.title') }}</span>
      </v-card-title>
      <v-card-text class="pl-4 red--text">
        <v-icon color="red">error</v-icon>  <span class="pa-3">{{ $t('denied.' + msg) }}</span>
      </v-card-text>

      </div>
  </m-layout>
</template>
<script>
export default {
  data () {
    return {
      msg: null
    };
  },
  methods: {
    eventClick: function (e) {
      console.log('event clicked', e);
    },
    getData () {

    }
  },
  created () {
    if (this.$route.query) {
      this.msg = this.$route.query.error
    }
  }
};
</script>
<style lang="scss">
</style>
